<template>
  <div class='theme-filter-checkbox__holder'>
    <div
      :class="['theme-filter-checkbox',
      {
        'theme-filter-checkbox--column-direction': columnDirection,
        'theme-filter-checkbox--limited': limited && !showLimited
      }]"
    >
      <template v-if="Object.keys(options).length">
        <label
          :class="['theme-filter-checkbox__item']"
          v-for="(option, key) in options"
          :key="key"
        >
          <input
            :name="name"
            type="checkbox"
            :value="key"
            v-model="model"
            :id="`${name}-${key}`"
            @change="stateChange(model);"
          />
          <div class="theme-filter-checkbox__indicator"/>
          <template v-if="option">
            <span class="theme-filter-checkbox__item-label" v-html='option'></span>
          </template>
        </label>
      </template>
    </div>
    <div v-if='limited' class='theme-filter-checkbox__show-more'>
      <a href='#' class='theme-btn theme-btn--text' @click.prevent='showLimited = !showLimited'>
        <template v-if='showLimited'>
          Show less
          <i class='icon-thin-up'/>
        </template>
        <template v-else>
          Show more
          <i class='icon-thin-down'/>
        </template>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      isDirty() {
        return !!this.model
      }
    },
    data() {
      return {
        model: Array.isArray(this.values) ? this.values : [this.values],
        showLimited: false
      }
    },
    methods: {
      stateChange(model) {
        this.$emit('changed', model);
      },
    },
    props: {
      options: {
        default: () => { return {} },
        type: [Object, Array]
      },
      values: {
        default: () => { return [] },
        type: [Array, String]
      },
      name: {
        default: '',
        type: String
      },
      columnDirection: {
        default: false,
        type: Boolean,
      },
      limited: {
        default: false,
        type: Boolean,
      },
    }
  }
</script>


// WEBPACK FOOTER //
// resources/js/components/ThemeFilterCheckboxes.vue